webpackJsonp([60],{

/***/ "3/kj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-payment-details-with-card_098bae1782bb29a970845da527209289.html";

/***/ }),

/***/ "mhCG":
/***/ (function(module, exports, __webpack_require__) {

var SubscriptionPaymentDetailsWithCard = (function () {
    function SubscriptionPaymentDetailsWithCard() {
    }
    return SubscriptionPaymentDetailsWithCard;
}());
angular
    .module('animatronApp.SubscriptionPaymentDetailsWithCard', [])
    .component('subscriptionPaymentDetailsWithCard', {
    bindings: {
        status: '<',
        type: '<',
        last4: '<',
        expires: '<',
        errorMessage: '<?',
        onChange: '&?'
    },
    controller: SubscriptionPaymentDetailsWithCard,
    templateUrl: __webpack_require__("3/kj")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/60-c7c98a0cc108ea8b91f3.min.js